import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import {
  Dialog,
  DialogTitle,
  Tabs,
  Tab,
  DialogContent,
  Button,
} from "@material-ui/core";
import Historial from "./historial";
import NuevoSeguimiento from "./nuevoSeguimiento";
import BuscarGuia from "./buscarGuia";
import InformacionGuia from "./informacionGuia";
import HistorialEntregas from "./historialEntregas";
import { AuthContext } from "../../../context/authContext.js";
import ACCESS from "../../../ACCESS.js";

class SeguimientoGuiasTable extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: "guia-comentario/filter",
        deleteUrl: "banco/delete",
        deleteField: "banco_nombre",
        modUrl: "/Catalogo/Banco",
      },
      TableOp.Table(
        "Seguimiento de Guias",
        [
          { label: "Guia", id: "g_folio" },
          { label: "Tipo Seguimiento", id: "tipo_seguimiento_guia" },
          {
            label: "Fecha Proximo Seguimiento",
            id: "fecha_proximo_seguimiento",
          },
          {
            label: "Finalizado",
            id: "finalizado",
          },
          { label: "Usuario", id: "usuario" },
          { label: "Estatus Actual", id: "descripcion" },
          { label: "Sucursal Origen", id: "sucursal_origen" },
          { label: "Sucursal Destino", id: "sucursal_destino" },
          { label: "Cliente", id: "cliente" },
        ],
        [{ id: "show", icon: "visibility" }]
      )
    );
    this.table();
  }

  action = (id, row) => {
    if (id === "show") {
      this.setState({
        currentGuia: row,
        showDialog: true,
        modalMode: "show",
        tabValue: "info_guia",
      });
    }
  };

  handleDialog = async (showDialog) => {
    this.setState({ showDialog: showDialog });
    if (showDialog === false) {
      this.setState({ currentGuia: false });
    }
  };

  handleChangeTab = async (tabValue) => {
    this.setState({ tabValue });
  };

  handleCreateModal = () => {
    this.setState({
      modalMode: "create",
      tabValue: "info_guia",
      showDialog: true,
    });
  };

  render() {
    const {
      showDialog = false,
      currentGuia,
      tabValue = "info_guia",
      modalMode,
    } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          {
            hasAccess(ACCESS.SEGUIMIENTO_DE_GUIA.CREAR_SEGUIMIENTO) &&
            <Button
              onClick={this.handleCreateModal}
              color={"primary"}
              variant={"contained"}
            >
              Nuevo Seguimiento
            </Button>
          }
        </div>
        
        <this.TableRender />

        {/** Modal */}
        <Dialog
          open={showDialog}
          onClose={() => this.handleDialog(false)}
          maxWidth={"xl"}
          fullScreen
        >
          <DialogTitle>Informacion Guia</DialogTitle>
          <DialogContent>
            <div style={{ minWidth: 800 }}>
              <BuscarGuia
                onChangeGuia={(guia) => {
                  this.setState({ currentGuia: guia });
                }}
              />
              {currentGuia ? (
                <>
                  <Tabs
                    value={tabValue}
                    onChange={(e, newValue) => {
                      this.handleChangeTab(newValue);
                    }}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs"
                  >
                    <Tab value={"info_guia"} label="Informacion" />
                    <Tab value={"historial"} label="Historial" />
                    <Tab value={"entregas"} label="Entregas y Acuses" />
                    { currentGuia.finalizado === "Si"
                      ? ''
                      : <Tab value={"nuevo_comentario"} label="Nuevo Comentario" />
                    }
                  </Tabs>
                  {
                    {
                      info_guia: <InformacionGuia guia={currentGuia} />,
                      historial: <Historial guia={currentGuia} />,
                      entregas: <HistorialEntregas guia={currentGuia} />,
                      nuevo_comentario: (
                        <NuevoSeguimiento
                          guia={currentGuia}
                          mode={modalMode}
                          onSave={() => {
                            this.table();
                            this.handleDialog(false);
                          }}
                        />
                      ),
                    }[tabValue]
                  }
                </>
              ) : (
                <div />
              )}
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                onClick={() => this.handleDialog(false)}
                color="primary"
                variant="contained"
              >
                Cerrar
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

SeguimientoGuiasTable.contextType = AuthContext;
export default withRouter(SeguimientoGuiasTable);
